import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ArticlePreview from "../../articles/ArticlePreview";
import NavigationButton from "../../ui/NavigationButton";
import ArticleIndicators from "../../ui/ArticleIndicators";
import { generateSlug, getCategoryPath } from "../../../utils/slugUtils";

// Reusable article grid with navigation
export default function ArticleGrid({
  articles,
  currentIndex,
  articlesPerPage,
  totalPages,
  totalArticles,
  onPrevious,
  onNext,
  canGoPrevious,
  canGoNext,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation("home");
  const currentPage = Math.floor(currentIndex / articlesPerPage);

  // Handle article click for internal navigation
  const handleArticleClick = (article) => {
    const slug = article.slug || generateSlug(article.title);
    const categoryPath = getCategoryPath(article.category);
    navigate(`${categoryPath}/${slug}`);
  };

  return (
    <div className="relative">
      {/* Navigation Buttons */}
      <div className="flex justify-between items-center mb-8">
        <NavigationButton
          direction="left"
          onClick={onPrevious}
          disabled={!canGoPrevious}
        />

        <div className="text-gray-400 text-sm">
          {t("magazine.pagination", {
            start: currentIndex + 1,
            end: Math.min(currentIndex + articlesPerPage, totalArticles),
            total: totalArticles,
          })}
        </div>

        <NavigationButton
          direction="right"
          onClick={onNext}
          disabled={!canGoNext}
        />
      </div>

      {/* Articles Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {articles.map((article) => (
          <ArticlePreview
            key={article.id}
            image={article.image}
            title={article.title}
            excerpt={article.excerpt}
            author={article.author}
            date={article.date}
            readTime={article.readTime}
            category={article.category}
            imageAlt={article.imageAlt}
            articleUrl={article.articleUrl}
            onClick={handleArticleClick}
            article={article}
          />
        ))}
      </div>

      {/* Article Indicators */}
      <ArticleIndicators totalPages={totalPages} currentPage={currentPage} />
    </div>
  );
}
